import { useState } from "react";
import { PopupModal } from "react-calendly";
import { Button } from "www/shared/components/buttons/Button";
import Container from "www/shared/components/container/Container";

const BookDemoSection = ({
  headerText,
  subtitleText,
  showDemoButton,
}: {
  headerText: string;
  subtitleText: string;
  showDemoButton: boolean;
}) => {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  return (
    <section
      id="demo"
      className="bg-green-700 py-28 relative overflow-hidden bg-[url('/marketing/sponsors/features/features_bg.jpg')] bg-center"
    >
      <Container className="max-w-4xl flex flex-col items-center text-center mx-auto relative">
        <h2 className="text-white text-3xl sm:text-4xl lg:text-5xl font-semibold">
          {headerText}
        </h2>
        <p className="text-white text-lg mt-5">{subtitleText}</p>
        {showDemoButton && (
          <Button
            variant="filledWhite"
            className="px-5 py-3 mt-8 lg:mt-12"
            onClick={() => setIsCalendlyOpen(true)}
          >
            Book demo
          </Button>
        )}
      </Container>
      {isCalendlyOpen && showDemoButton && (
        <PopupModal
          url="https://calendly.com/ajaysohmshetty/30min"
          pageSettings={{
            hideEventTypeDetails: false,
          }}
          rootElement={document.getElementById("calendly-root") as HTMLElement}
          open={isCalendlyOpen}
          onModalClose={() => setIsCalendlyOpen(false)}
        />
      )}
    </section>
  );
};

export default BookDemoSection;
